import { render, staticRenderFns } from "./Hotelscheme.vue?vue&type=template&id=49874154&scoped=true&"
import script from "./Hotelscheme.vue?vue&type=script&lang=js&"
export * from "./Hotelscheme.vue?vue&type=script&lang=js&"
import style0 from "./Hotelscheme.vue?vue&type=style&index=0&id=49874154&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49874154",
  null
  
)

export default component.exports